<template>
  <div class="welcome">
    <div class="page-login--layer page-login--layer-area">
      <ul class="circles">
        <li v-for="n in 10" :key="n"></li>
      </ul>
    </div>
    <div class="welcome-content">
      <div class="greeting-section">
        <div class="greeting-icon">👋</div>
        <h1 class="greeting-text">{{ greetingText }}，{{ userName }}</h1>
        <p class="greeting-sub">欢迎登录数据中心后台管理系统</p>
        <div class="time-info">
          <span class="time-item">
            <i class="el-icon-date"></i>
            {{ currentDate }}
          </span>
          <span class="time-item">
            <i class="el-icon-time"></i>
            {{ currentTime }}
          </span>
        </div>
      </div>

      <div class="quick-actions">
        <div class="action-title">快捷入口</div>
        <div class="action-list">
          <div class="action-item" @click="$router.push('/withdraw')">
            <i class="el-icon-money"></i>
            <span>提现管理</span>
          </div>
          <div class="action-item" @click="$router.push('/lease')">
            <i class="el-icon-document"></i>
            <span>预约订单</span>
          </div>
          <div class="action-item" @click="$router.push('/merchant')">
            <i class="el-icon-s-shop"></i>
            <span>商家管理</span>
          </div>
          <div class="action-item" @click="$router.push('/devices')">
            <i class="el-icon-monitor"></i>
            <span>设备管理</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welcome',
  data() {
    return {
      currentTime: '',
      currentDate: '',
      timer: null
    }
  },
  computed: {
    greetingText() {
      const hour = new Date().getHours()
      if (hour < 6) return '🌙 凌晨好'
      if (hour < 9) return '🌅 早上好'
      if (hour < 12) return '☀️ 上午好'
      if (hour < 14) return '🌤️ 中午好'
      if (hour < 18) return '⛅ 下午好'
      if (hour < 22) return '🌆 晚上好'
      return '🌙 夜深了'
    },
    userName() {
      return sessionStorage.getItem('username') || '管理员'
    }
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const weekDays = ['日', '一', '二', '三', '四', '五', '六']
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      this.currentDate = `${y}年${m}月${d}日 星期${weekDays[now.getDay()]}`
      const h = String(now.getHours()).padStart(2, '0')
      const min = String(now.getMinutes()).padStart(2, '0')
      const s = String(now.getSeconds()).padStart(2, '0')
      this.currentTime = `${h}:${min}:${s}`
    }
  }
}
</script>

<style lang="less" scoped>
.welcome {
  min-width: 1080px;
  padding: 0 15px;
  position: relative;
  min-height: calc(100vh - 120px);
}

.welcome-content {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  padding-top: 40px;
}

.greeting-section {
  text-align: center;
  margin-bottom: 50px;
  animation: fadeInDown 0.8s ease;

  .greeting-icon {
    font-size: 56px;
    margin-bottom: 10px;
    animation: wave 1.5s ease-in-out infinite;
    display: inline-block;
  }

  .greeting-text {
    font-size: 56px;
    font-weight: 700;
    color: #2a3948;
    margin: 10px 0 8px;
  }

  .greeting-sub {
    font-size: 26px;
    color: #8c9fbe;
    margin: 0 0 20px;
  }

  .time-info {
    display: flex;
    justify-content: center;
    gap: 30px;

    .time-item {
      font-size: 15px;
      color: #666;
      background: rgba(255, 255, 255, 0.8);
      padding: 8px 20px;
      border-radius: 20px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);

      i {
        margin-right: 6px;
        color: #3e79d3;
      }
    }
  }
}

.quick-actions {
  animation: fadeInUp 0.8s ease 0.4s both;

  .action-title {
    font-size: 18px;
    font-weight: 700;
    color: #2a3948;
    margin-bottom: 20px;
    padding-left: 12px;
    border-left: 4px solid #3e79d3;
  }

  .action-list {
    display: flex;
    gap: 20px;

    .action-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 28px 20px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 30px rgba(62, 121, 211, 0.15);
        color: #3e79d3;

        i { color: #3e79d3; }
      }

      i {
        font-size: 32px;
        color: #8c9fbe;
        margin-bottom: 10px;
        transition: color 0.3s ease;
      }

      span {
        font-size: 14px;
        color: #555;
      }
    }
  }
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  25% { transform: rotate(20deg); }
  75% { transform: rotate(-15deg); }
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ecf3 100%);
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: -1;

  li {
    position: absolute;
    display: block;
    list-style: none;
    width: 20px;
    height: 20px;
    background: rgba(62, 121, 211, 0.08);
    animation: animate 25s linear infinite;
    bottom: -200px;

    @keyframes animate {
      0% {
        transform: translateY(0) rotate(0deg);
        opacity: 0.6;
        border-radius: 50%;
      }
      100% {
        transform: translateY(-1000px) rotate(720deg);
        opacity: 0;
        border-radius: 0;
      }
    }

    &:nth-child(1) { left: 15%; width: 80px; height: 80px; animation-delay: 0s; }
    &:nth-child(2) { left: 5%; width: 20px; height: 20px; animation-delay: 2s; animation-duration: 12s; }
    &:nth-child(3) { left: 70%; width: 20px; height: 20px; animation-delay: 4s; }
    &:nth-child(4) { left: 40%; width: 60px; height: 60px; animation-delay: 0s; animation-duration: 18s; }
    &:nth-child(5) { left: 65%; width: 20px; height: 20px; animation-delay: 0s; }
    &:nth-child(6) { left: 75%; width: 150px; height: 150px; animation-delay: 3s; }
    &:nth-child(7) { left: 35%; width: 200px; height: 200px; animation-delay: 7s; }
    &:nth-child(8) { left: 50%; width: 25px; height: 25px; animation-delay: 15s; animation-duration: 45s; }
    &:nth-child(9) { left: 20%; width: 15px; height: 15px; animation-delay: 2s; animation-duration: 35s; }
    &:nth-child(10) { left: 85%; width: 150px; height: 150px; animation-delay: 0s; animation-duration: 11s; }
  }
}
</style>
